import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

// The hub and the LMU TV storefront are either/or (see below), so each one is its own
// chunk: a visitor only downloads the app that is actually rendered.
const HubRoot = React.lazy(() => import("./HubRoot"));
const LmuTvRoot = React.lazy(() =>
  import("./lmutv/LmuTvRoot").then((m) => ({ default: m.LmuTvRoot }))
);

export const DEBUG = process.env.NODE_ENV === 'development';
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// Top-level app switch: the same build serves the SimRacing hub AND the migrated
// LMUTV storefront. LMUTV takes over when served from its own domain (lmutv.de)
// or reached via the /lmutv path on the hub. Either/or at the root — never a nested
// <Router> — with a basename so LMUTV's absolute routes resolve under both entries.
// A per-app build (e.g. a subdomain that only serves LMUTV) can force the shell
// with REACT_APP_APP=lmutv — then it renders LMUTV at the domain root regardless of
// hostname. Otherwise fall back to host/path detection: lmutv.de → LMUTV at root,
// /lmutv on the hub → LMUTV under that subpath.
const forcedApp = process.env.REACT_APP_APP;
const lmuTvHost = /(^|\.)lmutv\.de$/i.test(window.location.hostname);
const lmuTvPath =
  window.location.pathname === "/lmutv" || window.location.pathname.startsWith("/lmutv/");
const showLmuTv = forcedApp === "lmutv" || lmuTvHost || lmuTvPath;
const lmuTvBasename = forcedApp === "lmutv" || lmuTvHost ? "/" : "/lmutv";

root.render(
  <React.StrictMode>
    <Suspense fallback={<></>}>
      {showLmuTv ? <LmuTvRoot basename={lmuTvBasename} /> : <HubRoot />}
    </Suspense>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
